import { Equipo } from "@/domain/entities/equipo";
import { Header } from "@/presentation/components";
import { DataTable, DataTableColumn } from "@/presentation/components/common/DataTable";
import { Detail, DetailSection } from "@/presentation/components/DetailCard/DetailCard";
import { AppDrawer } from "@/presentation/components/layout/AppDrawer/AppDrawer";
import { BottomAppBar } from "@/presentation/components/layout/BottomAppBar";
import { useAuthContext } from "@/presentation/context";
import { useEquipo } from "@/presentation/hooks/useEquipo";
import { useIncidente } from "@/presentation/hooks/useIncidente";
import { routes } from "@/presentation/router";
import { formatPriority, formatState, formatStateE } from "@/shared";
import { formatSmartDateTime } from "@/shared/utils/dateFormaters";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function EquipoDetailPage() {
  const navigate = useNavigate();
  const { user, logout } = useAuthContext();

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  const handleLogout = async () => {
    await logout();
    setIsDrawerOpen(false);
    navigate(routes.login, { replace: true });
  };
  const { id } = useParams<{ id: string }>();
  const {
      data: incidentes,
      error: incidentesError,
      loadAll,
    } = useIncidente();
  useEffect(() => {
    if (id) {
      // El hook expone el error para mostrarlo en la página.
      void loadAll({ id_equipo: Number(id) }).catch(() => {});
    }
  }, [id, loadAll]);

  const {
    Equipo,
    error: equipoError,
    loadById,
  } = useEquipo();

  useEffect(() => {
    if (id) {
      void loadById(id).catch(() => {});
    }
  }, [id, loadById]);

  if (equipoError) {
    return <p role="alert">{equipoError}</p>;
  }

  if (!Equipo) {
    return <>Cargando...</>;
  }
  const EquipoDetailSections: DetailSection<Equipo>[] = [
    {
      title: "Información General",
      fields: [
        {
          label: "Equipo",
          key: "equipo",

        },
        {
          label: "Ubicación",
          key: "ubicacion",
          onSelect: () => {
            navigate(`/ubicacion/${Equipo.id_ubicacion}`);
          },
        },

        {
          label: "Grupo",
          key: "grupo",
        },
        {
          label: "Usuario",
          key: "usuario",
        },
        {
          label: "Fecha de Alta",
          key: "fecha",
          render: (value) => formatSmartDateTime(new Date(value as number))
        },

      ],
    },
    {
      title: "Especificaciones",
      fields: [
        {
          label: "Lote",
          key: "lote",
        },
        {
          label: "Estado",
          key: "estado",
          render: (value) => formatStateE(value as number)
        },
        {
          label: "Tipo",
          key: "tipo",
        },
      ],
    }
  ];
  const columns: DataTableColumn<any>[] = [
      {
        key: 'estado',
        header: 'Estado',
        render: (incidente) => (
          formatState(incidente.estado)
        )
      },
      {
        key: 'prioridad',
        header: 'Prioridad',
        render: (incident) => formatPriority(incident.prioridad),
      },
      {
        key: 'tipo',
        header: 'Tipo',
      },
      {
        key: 'iniciado',
        header: 'Iniciado',
        render: (incident) =>
          formatSmartDateTime(incident.iniciado),
      },
      {
        key: 'responsable',
        header: 'Responsable',
        render: (incidente) =>
      Number(incidente.tipo_responsable) === 2
        ? `${incidente.responsable} - Externo`
        : incidente.responsable,
      },
  
    ];
  





  return (
    <div>
      <Header
        title="Detalle del Equipo"
        onMenuClick={handleOpenDrawer}
      />

      <AppDrawer
        isOpen={isDrawerOpen}
        user={user}
        onClose={handleCloseDrawer}
        onLogout={handleLogout}
      />
      <main className="detail-page__content">
              <Detail
                data={Equipo}
                sections={EquipoDetailSections}
              />
      
              <section
                className="detail-page__list"
                aria-labelledby="equipos-asociados-title"
              >
                <div className="detail-page__section-header">
                  <div>
                    <h2 id="equipos-asociados-title">Incidentes</h2>
                    <p>Incidentes ocurridos en este equipo.</p>
                  </div>
      
                  <span className="detail-page__count">
                    {incidentes.length}
                  </span>
                </div>
      
                {incidentesError && <p role="alert">{incidentesError}</p>}
                <DataTable
                  columns={columns}
                  data={incidentes}
                  onRowClick={(incidente) =>
                    navigate(`/incidente/${incidente.id}`)
                  }
                  emptyMessage="No hay incidentes cargados"
                />
              </section>
              </main>




      <BottomAppBar
        items={[
          {
            label: 'Editar',
            onClick: () => { navigate(`/equipo/formulario/${id}`) },
            icon: undefined,
          },
        ]}
      />
    </div>
  );
}
